import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

const TARGET_LAT = 38.37015;
const TARGET_LON = -8.968333;

function getDistanceFromLatLonInM(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000; // Distance in m
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export default function GPS({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>GPS</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}:
          <p style={{ marginLeft: '1em' }}>
            Satellites: {formatValue(parseFloat(d.num_sats), 0)}<br />
            {d.latitude !== 0 && <>Latitude: {formatValue(d.latitude, 6)}<br /></>}
            {d.longitude !== 0 && <>Longitude: {formatValue(d.longitude, 6)}<br /></>}
            {d.latitude !== 0 && d.longitude !== 0 && (
              <>Deviation: {formatValue(getDistanceFromLatLonInM(d.latitude, d.longitude, TARGET_LAT, TARGET_LON), 2)} m<br /></>
            )}
            {d.latitude !== 0 && d.longitude !== 0 && (
              <>
                <a
                  href={`https://www.google.com/maps?q=${d.latitude},${d.longitude}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Maps
                </a>
                <br />
              </>
            )}
          </p>
        </div>
      ))}
    </Item>
  );
}
